import React, { useEffect, useState } from 'react'
import shoppingCart from 'assets/shoppingCart.svg'
import { Counter, Button, Icon } from './styles'
import { useLocation } from 'react-router-dom'
import { getQueryParamsValue } from 'utils'
import { CurrentLaboratoryType } from 'typings/auth'
import { STORAGE_CURRENT_LABORATORY } from 'constants/storageKeys'

type ShoppingCartProps = {
    setShowModalOrBottomSheet: (valeu: boolean) => void
    currentLaboratory: string
}

export const ShoppingCart = ({ setShowModalOrBottomSheet, currentLaboratory }: ShoppingCartProps) => {
    const location = useLocation()
    const [numberOfItems, setNumberOfItems] = useState<number>(0)
    const productIds = getQueryParamsValue(location, 'productIds')
    const dataItemPosition = `LP ${currentLaboratory}`

    const data: CurrentLaboratoryType = JSON.parse(sessionStorage.getItem(STORAGE_CURRENT_LABORATORY) || '{}')

    useEffect(() => {
        if (!productIds) {
            setNumberOfItems(0)
        }

        productIds && setNumberOfItems(productIds.split(',').length)
        data.numberOfItems && setNumberOfItems(data.numberOfItems)
    }, [productIds, data])

    const handleClick = () => {
        setShowModalOrBottomSheet(true)
    }

    if (numberOfItems) {
        return (
            <Button
                data-current-service="Onboarding"
                data-item-position={dataItemPosition}
                data-item-text="Carrinho"
                data-testid="shopping-cart-button"
                onClick={handleClick}
            >
                <Icon alt="Shopping Cart" src={shoppingCart} />
                <Counter>{numberOfItems}</Counter>
            </Button>
        )
    }
    return null
}
